import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache } from '@apollo/client';
import { ThemeProvider } from '@mui/material';
import React from 'react';

import { config } from '../config/loader.js';
import BioacousticsPage from '../pages/bioacoustics/BioacousticsPage.js';
import EDNAPage from '../pages/edna/EDNAPage.js';
import { LanguageContext } from '../providers/LanguageContext.js';
import { theme } from '../theme/theme.js';

export const apolloClient = new ApolloClient({
  link: new HttpLink({ uri: `${config.backendUrl}/graphql` }),
  cache: new InMemoryCache(),
  ssrMode: import.meta.env.SSR,
});

const publicLanguage = { language: 'en' as const, setLanguage: () => {}, loading: false };

const pages: Array<{ key: string; path: string; component: React.ComponentType }> = [
  { key: 'bioacoustics', path: '/bioacoustics', component: BioacousticsPage },
  { key: 'edna', path: '/edna', component: EDNAPage },
];

export const Layout: React.FC<{ children: React.ReactNode; page: string }> = ({ children, page }) => (
  <div data-ssg-page={page}>
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <LanguageContext.Provider value={publicLanguage}>
          {children}
        </LanguageContext.Provider>
      </ThemeProvider>
    </ApolloProvider>
  </div>
);

export const PAGE_COMPONENTS: Record<string, React.ReactNode> = Object.fromEntries(
  pages.map(({ key, component: Component }) => [key, <Component key={key} />])
);

export const ssgRoutes = pages.map(({ key, path, component: Component }) => ({
  path,
  element: <Layout page={key}><Component /></Layout>,
}));
